<template>
    <div class="theme">
        <div class="theme-header">
            <h3 class="theme-title">主题旅行</h3>
            <div class="line-bold"></div>
        </div>
        <div class="theme-sub-title">
            浪漫、温馨、趣味花样主题
        </div>
        <div class="theme-refresh">
            <div class="theme-refresh-name" @click='tosee'>去看看</div>
            <div class="theme-refresh-img"></div>
        </div>
        <div class="theme-lists-content">
          <Lists :lists="lists"></Lists>
        </div>
    </div>
</template>

<script>
import HotRouterImg from '@/assets/img/hot-router-img.png'
import TimeIcon from '@/assets/img/time-icon.png'
import Lists from '@/components/ListsContent.vue'
import {querycontent} from '@/api/content.js'
import {getthemelist} from '@/api/theme.js'
import { sliceDate } from '@/utils/index'

export default {
  name: 'Theme',
  data () {
    return {
      TimeIcon,
      lists: [
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: HotRouterImg,
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          active: true
        },
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          imgPath: HotRouterImg,
          active: false
        },
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          imgPath: HotRouterImg,
          active: false
        }
      ],
      queylist: {
        page: 1,
        limit: 3,
        menuId: undefined,
        themeId: -1,
        sort: 'order_no',
        order: 'asc'
      },
      themes: {}
    }
  },
  components: {
    Lists
  },
  methods: {
    tosee () {
      this.$router.push({
        name: 'ThemeLists'
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        this.menus = res.data.data.items
        let themes = res.data.data.items
        themes.forEach(element => {
          this.themes[element.id] = element.tname
        })
        this.gettheme()
      })
    },
    gettheme () {
      querycontent(this.queylist).then(res => {
        this.lists = res.data.data.items
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          console.log(this.themes)
          items[i].classes = this.themes[items[i].themeId]
        }
      })
    }
  },
  created () {
    this.getthemelist()
  }
}
</script>

<style lang="scss" scoped>
.theme {
    margin-top: 60px;
    width: 100%;
    .theme-header {
        width: 780px;
        border-bottom: 1px solid #dae1e6;
        margin: 0 auto;
        position: relative;
        padding-bottom:8px;
    }
    .theme-title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 34px;
        color: #60676d;
    }
    .line-bold {
        width: 44px;
        height: 3px;
        position: absolute;
        left: 50%;
        bottom: -2px;
        margin-left: -22px;
        background: #0080cc;
    }
    .theme-sub-title {
        width: 100%;
        text-align: center;
        color: #a3abb2;
        font-size: 16px;
        margin-top: 10px;
    }
    .theme-refresh {
        width: 1232px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0 auto;
        cursor: pointer;
        &:hover {
            .theme-refresh-name {
                color: #a0d7f9;
            }
            .theme-refresh-img {
                background: url(../../assets/img/right-icon.png);
            }
        }
    }
    .theme-refresh-name {
        font-size: 14px;
        color: #c0c6c9;
        font-weight: bold;
    }
    .theme-refresh-img {
        width: 10px;
        height: 9px;
        margin-left: 6px;
        background: url(../../assets/img/right-gray-icon.png);
    }
    .theme-lists-content {
      width: 1232px;
      margin: 0 auto;
      margin-top: -10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/theme.vue